import ReactGA from 'react-ga4';

const SEARCH_TYPE_MAP = {
  nhle: 'NHLE',
  har: 'HAR',
  archive: 'Archive Search',
  ['educational-images']: 'Educational Images',
  gap: 'Grant Aided Places',
  ['research-reports']: 'Research Reports',
  site: 'Search the site',
  ['teaching-activities']: 'Education Teaching Activities',
  publications: 'Publications',
  ['heritage-gateway']: 'Heritage Gateway',
};

export function getSearchType() {
  if (typeof document === 'undefined') {
    return '';
  }

  const rootElement = document.getElementById('root');
  const type = rootElement?.getAttribute('data-search-type') || '';

  return SEARCH_TYPE_MAP[type];
}

export function camelToTitle(str) {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, char => char.toUpperCase())
    .trim();
}

export function trackFilterSelection(filterField, filterValue) {
  try {
    if (filterValue === '' || !filterValue) {
      return;
    }

    ReactGA.event('search_filter_applied', {
      filter_field: camelToTitle(filterField),
      filter_value: Array.isArray(filterValue)
        ? filterValue.join(', ')
        : filterValue,
      search_type: getSearchType(),
    });
  } catch (e) {
    console.error('Filter tracking failed', e);
  }
}

export function trackPaginationSelection(pageNumber) {
  try {
    if (!pageNumber || pageNumber < 1) {
      return;
    }

    ReactGA.event('search_page_changed', {
      page_number: pageNumber,
      search_type: getSearchType(),
    });
  } catch (e) {
    console.error('Pagination tracking failed', e);
  }
}

export function trackSearchResultClick(
  resultId,
  resultIndex,
  resultTitle,
  resultUrl,
  pageNumber,
  pageSize,
  searchTerm,
) {
  try {
    const fullResultUrl = new URL(resultUrl, window.location.origin).href;

    ReactGA.event('search_result_clicked', {
      event_category: 'Search Results Clicked',
      page_number: pageNumber,
      page_size: pageSize,
      result_id: resultId,
      result_index: resultIndex,
      result_title: resultTitle,
      result_url: fullResultUrl,
      search_term: searchTerm ?? '',
      search_type: getSearchType(),
    });
  } catch (e) {
    console.error('Search result click tracking failed', e);
  }
}
